import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Tabs from "./components/Tabs";
import { LogisticAction } from "redux/actions";
import HomeTab from "logistic-integrations/components/HomeTab";
const Ifast = ({ order, fetchOrderDetailsByID }) => {
  const dispatch = useDispatch();
  const { ifastModal } = useSelector((state) => state.LogisticReducer);

  return (
    <HomeTab
      {...{
        order,
        fetchOrderDetailsByID,
        isOpen: ifastModal,
        onClose: () => {
          dispatch(LogisticAction.toggleIfastModal(false));
        },
      }}
    >
      <Tabs
        {...{ order, fetchOrderDetailsByID }}
        setOpen={() => {
          dispatch(LogisticAction.toggleIfastModal(false));
        }}
      />
    </HomeTab>
  );
};

export default Ifast;
